// Flush all array
export function flush(state) {
  state.all = [];
} // Set all directly

export function setAll(state, payload) {
  state.all = payload;
}
export function updateLifetime(state) {
  var date = new Date();
  date.setHours(date.getHours() + 1);
  state.expires = date.getTime();
}